export default {
    VITRIOL: 'Vitriol',
    REBIS: 'Rebis',
    AETHER: 'Aether',
    QUEBRITH: 'Quebrith',
    HYDRAGENUM: 'Hydragenum',
    VERMILION: 'Vermilion',
    SOL: 'Sol',
    CAELUM: 'Caelum',
    FULGUR: 'Fulgur',

    RED_MUTAGEN: 'Red Mutagen',
    GREEN_MUTAGEN: 'Green Mutagen',
    BLUE_MUTAGEN: 'Blue Mutagen',

    OTHER: 'Other',
}